import React, { useEffect, useState } from 'react';
import { CONTACT, NOW } from '../../data/portfolio';
import type { ViewName } from '../../types';
import KnowledgeGraph from './KnowledgeGraph';

interface HomeProps {
  onGo: (name: ViewName) => void;
  onOpenProject: (id: string) => void;
}

const Home: React.FC<HomeProps> = ({ onGo, onOpenProject }) => {
  const [clock, setClock] = useState('');

  useEffect(() => {
    const tick = () => {
      setClock(
        new Date().toLocaleTimeString('en-US', {
          timeZone: 'America/New_York',
          hour12: false,
        })
      );
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div id="now">
      <div className="now-left">
        <div className="topbar">
          <h1>sahil chordia</h1>
          <p>
            ai engineer · {CONTACT.location.toLowerCase()} ·{' '}
            <span className="cy">{clock} et</span>
          </p>
        </div>

        <div className="hero">
          <h2>
            I design, build, and ship AI agents: autonomous enough to act,{' '}
            <em>engineered enough to trust.</em>
          </h2>
          <p className="who">
            {NOW.education.degree.toLowerCase()} · {NOW.education.school.toLowerCase()}
          </p>
          <p className="status">
            <i />
            available for work
          </p>
          <div className="hero-acts">
            <button type="button" className="hero-cta" onClick={() => onGo('projects')}>
              view projects →
            </button>
            <button type="button" className="hero-cta ghost" onClick={() => onGo('about')}>
              model card
            </button>
          </div>
        </div>
      </div>

      <div className="now-graph">
        <div className="kg-frame">
          <KnowledgeGraph onGo={onGo} onOpenProject={onOpenProject} />
        </div>
      </div>
    </div>
  );
};

export default Home;
